import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import FormationsPage from "./pages/FormationsPage";
import ConsultingPage from "./pages/ConsultingPage";
import RecruitmentPage from "./pages/RecruitmentPage";
import MoanaPaye from "./pages/MoanaPaye";
import RoomRentalPage from "./pages/RoomRentalPage";
import RoomSitesPage from "./pages/RoomSitesPage";
import RoomSiteDetailPage from "./pages/RoomSiteDetailPage";
import RoomBookingPage from "./pages/RoomBookingPage";
import ContactPage from "./pages/ContactPage";
import EspaceClientPage from "./pages/EspaceClientPage";
import CourseViewerPage from "./pages/CourseViewerPage";
import AdminPage from "./pages/AdminPage";
import AdminEditorPage from "./pages/AdminEditorPage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import JobOffersPage from "./pages/JobOffersPage";
import CvBuilderPage from "./pages/CvBuilderPage";
import CoachInterviewPage from "./pages/CoachInterviewPage";
import EspaceEmploiPage from "./pages/EspaceEmploiPage";
import RseHybridePage from "./pages/RseHybridePage";
import CandidatDashboard from "./pages/CandidatDashboard";
import EmployeurDashboard from "./pages/EmployeurDashboard";
import { MentionsLegalesPage, CGVPage, CGUPage, ConfidentialitePage } from "./pages/LegalPages";
import { AuthProvider } from "./contexts/AuthContext";
import { MoanaPayeProvider } from "./contexts/MoanaPayeContext";
import MoanaPayeLayout from "./layouts/MoanaPayeLayout";
import MoanaPayeLogin from "./pages/moana-paye/MoanaPayeLogin";
import MoanaPayeDashboard from "./pages/moana-paye/MoanaPayeDashboard";
import EntreprisesPage from "./pages/moana-paye/EntreprisesPage";
import SalariesPage from "./pages/moana-paye/SalariesPage";
import ParametresPage from "./pages/moana-paye/ParametresPage";
import SimulationPage from "./pages/moana-paye/SimulationPage";
import AbsencesPage from "./pages/moana-paye/AbsencesPage";
import VariablesPaiePage from "./pages/moana-paye/VariablesPaiePage";
import DeclarationsPage from "./pages/moana-paye/DeclarationsPage";
import ReportingPage from "./pages/moana-paye/ReportingPage";
import AdministrationPage from "./pages/moana-paye/AdministrationPage";
import EspaceSalariePage from "./pages/moana-paye/EspaceSalariePage";
import CanonicalUpdater from "./components/CanonicalUpdater";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CanonicalUpdater />
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/formations" element={<FormationsPage />} />
              <Route path="/consulting" element={<ConsultingPage />} />
              <Route path="/recrutement" element={<RecruitmentPage />} />
              <Route path="/moana-paye" element={<MoanaPaye />} />
              <Route path="/location-salles" element={<RoomRentalPage />} />
              <Route path="/location-salles/sites" element={<RoomSitesPage />} />
              <Route path="/location-salles/sites/aerh-tahiti" element={<RoomSiteDetailPage />} />
              <Route path="/location-salles/reserver/:roomId" element={<RoomBookingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/espace-client" element={<EspaceClientPage />} />
              <Route path="/cours/:catalogId" element={<CourseViewerPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/editor/:courseId" element={<AdminEditorPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/offres" element={<JobOffersPage />} />
              <Route path="/cv-builder" element={<CvBuilderPage />} />
              <Route path="/coach-entretien" element={<CoachInterviewPage />} />
              <Route path="/espace-emploi" element={<EspaceEmploiPage />} />
              <Route path="/espace-emploi/candidat" element={<CandidatDashboard />} />
              <Route path="/espace-emploi/employeur" element={<EmployeurDashboard />} />
              <Route path="/audit-rse-hybride" element={<RseHybridePage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/cgv" element={<CGVPage />} />
              <Route path="/cgu" element={<CGUPage />} />
              <Route path="/confidentialite" element={<ConfidentialitePage />} />
            </Route>
            {/* Moana Paye SaaS - Layout separe */}
            <Route element={<MoanaPayeProvider><MoanaPayeLayout /></MoanaPayeProvider>}>
              <Route path="/moana-paye/dashboard" element={<MoanaPayeDashboard />} />
              <Route path="/moana-paye/entreprises" element={<EntreprisesPage />} />
              <Route path="/moana-paye/salaries" element={<SalariesPage />} />
              <Route path="/moana-paye/parametres" element={<ParametresPage />} />
              <Route path="/moana-paye/simulation" element={<SimulationPage />} />
              <Route path="/moana-paye/absences" element={<AbsencesPage />} />
              <Route path="/moana-paye/variables" element={<VariablesPaiePage />} />
              <Route path="/moana-paye/declarations" element={<DeclarationsPage />} />
              <Route path="/moana-paye/reporting" element={<ReportingPage />} />
              <Route path="/moana-paye/administration" element={<AdministrationPage />} />
              <Route path="/moana-paye/mon-espace" element={<EspaceSalariePage />} />
            </Route>
            <Route path="/moana-paye/login" element={<MoanaPayeProvider><MoanaPayeLogin /></MoanaPayeProvider>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
